import { loggedIn } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import { confirmedCCPharmacy } from '../../../redux/modules/neworder';

export const page = {
  path: paths.createOrder.ccConfirmPharmacy,
  isAllowed: [loggedIn],
};

export const confirmCollect = {
  actionPath: '/actions/create-order/confirm-collect',
  inputName: 'ccupdateDeliveryPrefs',
  action: () => confirmedCCPharmacy(),
};
